import { BackendSource } from "@/shared/api/firehose";
import { client } from "@/shared/api/pref-storage";

const endpoints = {
  GetUserPreferences: "/preferences/user",
  GetUserPreferenceByKey: (key: string) => `/preferences/user/${key}`,
  SetSourceColors: "/preferences/user/source.colors",
  UpdateNotificationsSound: "/preferences/notifications",
};

export const getUserPreferences = async () => {
  return client.get(endpoints.GetUserPreferences);
};

export const getUserPreferenceByKey = async (key: string) => {
  return (await client.get(endpoints.GetUserPreferenceByKey(key))).data
    ?.value as string;
};

export const setUserPreferenceByKey = async <T>(key: string, value: T) => {
  return client.patch(endpoints.GetUserPreferenceByKey(key), { value });
};

export const toggleNotificationsSound = async (value: {
  headlines: boolean;
  truth_social: boolean;
}) => {
  return client.patch(endpoints.UpdateNotificationsSound, value);
};

export const setSourceColors = async (
  colors: Record<BackendSource, string>
) => {
  return client.patch(endpoints.SetSourceColors, { value: colors });
};

export type WatchlistAlertMode = "off" | "highlight" | "filter" | "both";

export const setWatchlistAlertMode = async (mode: WatchlistAlertMode) => {
  return client.patch(endpoints.GetUserPreferenceByKey("watchlist.alert.mode"), {
    value: mode,
  });
};
